import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const VendorRegister = () => {
    const baseUrl =
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_BASE_URL_DEV
            : process.env.REACT_APP_BASE_URL_PROD;

    useEffect(() => window.scroll(0, 0), []);
    const navigate = useNavigate();

    const [registrationSuccess, setRegistrationSuccess] = useState(false);
    const [showPassword1, setShowPassword1] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const modalRef = useRef(null);

    const [data, setData] = useState({
        FullName: "",
        companyName: "",
        email: "",
        number: "",
        startSelling: "",
        companySize: "1-10",
        category: { categoryId: "", categoryTitle: "", logoImage: "" },
        address1: "",
        city: "",
        state: "",
        country: "",
        pincode: "",
        password: "",
        confirmPassword: "",
    });

    const [error, setError] = useState("");
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axios.get(`${baseUrl}/catogray/categories`);
                if (response.data) {
                    setCategories(response.data.message.data);
                }
            } catch (error) {
                console.error("Error fetching categories:", error);
                setError("Failed to fetch categories. Please try again later.");
            }
        };
        fetchCategories();
    }, [baseUrl]);

    const handleChange = ({ currentTarget: input }) => {
        setData({
            ...data,
            [input.name]: input.name === "email" ? input.value.toLowerCase() : input.value,
        });
    };

    // Phone number validation
    const validatePhoneNumber = (number) => {
        const regex = /^[+]?(\d{1,3})?(\d{10})$/; // Optional country code, followed by 10 digits
        return regex.test(number);
    };

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        // Validations
        if (!data.FullName.trim()) return setError("Please enter your name.");
        if (!validateEmail(data.email)) return setError("Please enter a valid email address.");
        if (!validatePhoneNumber(data.number)) return setError("Please enter a valid phone number.");
        if (data.password.length < 6) return setError("Password must be at least 6 characters.");
        if (data.password !== data.confirmPassword) return setError("Passwords do not match.");

        try {
            const url = `${baseUrl}/vendor/register`;
            const { data: res } = await axios.post(url, data);
            if (res) {
                setRegistrationSuccess(true);
            } else {
                setError("Registration failed. Please try again.");
            }
        } catch (err) {
            const message = err.response?.data?.message || "An error occurred. Please try again.";
            setError(message);
        }
    };

    const handleCategoryChange = (e) => {
        const selected = categories.find((c) => c.categoryTitle === e.target.value);
        setData({
            ...data,
            category: {
                categoryId: selected?.categoryId || "",
                categoryTitle: selected?.categoryTitle || "",
                logoImage: selected?.logoImage || "",
            },
        });
    };

    const closeModal = () => {
        setRegistrationSuccess(false);
        window.location.reload();
    };

    const handleOverlayClick = (e) => {
        if (e.target === modalRef.current) {
            closeModal();
        }
    };

    return (
        <>
            <div className="relative h-full xl:px-[calc((100%-1250px)/2)] px-3">
                <button
                    onClick={() => navigate(-1)}
                    className="absolute top-4 left-4 p-2 flex items-center space-x-2"
                >
                    <span className="material-symbols-outlined text-xl">arrow_back</span>
                </button>

                <div className="md:flex justify-between items-center h-full pt-20">
                    <div className="w-full md:w-[50%] mt-10 flex flex-col items-start">
                        <p className="text-[30px] font-[500] capitalize">Become a Vendor</p>
                        <p className="text-[36px] font-[600] py-4 capitalize">Start Selling With Us</p>
                        <img
                            src="/images/image.png"
                            alt="Vendor Banner"
                            className="lg:h-[450px] h-[200px] mt-10 w-full object-cover"
                        />
                    </div>

                    <div className="flex justify-center items-center mt-4 w-full md:w-[50%]">
                        <div className="w-full max-w-lg mx-auto">
                            <p className="text-[18px] font-semibold">Fill the form below</p>
                            <p className="text-[14px] font-medium py-4 mt-2">Basic Information</p>
                            <hr className="mb-4" />

                            <form onSubmit={handleSubmit}>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                    {[ 
                                        { label: "Full Name *", name: "FullName", placeholder: "Enter your Full Name" },
                                        { label: "Company Name *", name: "companyName", placeholder: "Enter your Company Name" },
                                        { label: "Work Email *", name: "email", type: "email", placeholder: "Your Work Email" },
                                        { label: "Phone Number *", name: "number", placeholder: "Enter your phone number" },
                                        { label: "City *", name: "city", placeholder: "Your City" },
                                        { label: "State *", name: "state", placeholder: "Enter your State" },
                                        { label: "Country *", name: "country", placeholder: "Your Country" },
                                        { label: "Pin Code *", name: "pincode", placeholder: "Enter your Pincode" }
                                    ].map(({ label, name, placeholder, type = "text" }) => (
                                        <div key={name} className="flex flex-col">
                                            <label htmlFor={name} className="text-sm text-[#333333] text-left mb-1">
                                                {label}
                                            </label>
                                            <input
                                                type={type}
                                                name={name}
                                                value={data[name]}
                                                onChange={handleChange}
                                                placeholder={placeholder}
                                                className="w-full h-[50px] px-3 border border-[#CFD3D4] rounded-[8px] outline-none"
                                            />
                                        </div>
                                    ))}
                                </div>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                                    <div className="flex flex-col">
                                        <label htmlFor="companySize" className="text-sm text-[#333333] text-left mb-1">
                                            Company Size
                                        </label>
                                        <select
                                            name="companySize"
                                            value={data.companySize}
                                            onChange={handleChange}
                                            className="w-full h-[50px] px-3 border border-[#CFD3D4] rounded-[8px] outline-none"
                                        >
                                            {["1-10", "11-50", "51-200", "200+"].map(size => (
                                                <option key={size} value={size}>{size}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="flex flex-col">
                                        <label htmlFor="category" className="text-sm text-[#333333] text-left mb-1">
                                            Category *
                                        </label>
                                        <select
                                            name="category"
                                            value={data.category.categoryTitle}
                                            onChange={handleCategoryChange}
                                            className="w-full h-[50px] px-3 border border-[#CFD3D4] rounded-[8px] outline-none"
                                        >
                                            <option value="">Select a category</option>
                                            {categories.map(c => (
                                                <option key={c.categoryId} value={c.categoryTitle}>
                                                    {c.categoryTitle}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <label htmlFor="address1" className="text-sm text-[#333333] text-left mb-1 block">
                                        Company Address
                                    </label>
                                    <textarea
                                        name="address1"
                                        rows={4}
                                        value={data.address1}
                                        onChange={handleChange}
                                        placeholder="Company Address"
                                        className="w-full px-3 py-2 border border-[#CFD3D4] rounded-[8px] outline-none resize-none"
                                    />
                                </div>

                                <p className="text-[14px] font-medium py-4 mt-6">Login Information</p>
                                <hr className="mb-4" />

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                                    {[ 
                                        { label: "Password *", name: "password", show: showPassword1, toggle: () => setShowPassword1(!showPassword1) },
                                        { label: "Confirm Password *", name: "confirmPassword", show: showPassword2, toggle: () => setShowPassword2(!showPassword2) }
                                    ].map(({ label, name, show, toggle }) => (
                                        <div key={name} className="flex flex-col relative">
                                            <label htmlFor={name} className="text-sm text-[#333333] text-left mb-1">
                                                {label}
                                            </label>
                                            <input
                                                type={show ? "text" : "password"}
                                                name={name}
                                                value={data[name]}
                                                onChange={handleChange}
                                                placeholder={label}
                                                className="w-full h-[50px] px-3 border border-[#CFD3D4] rounded-[8px] outline-none"
                                            />
                                            <button type="button" onClick={toggle} className="absolute inset-y-0 right-0 top-3 px-2">
                                                <span className="material-symbols-outlined text-[#333333]">
                                                    {show ? "visibility" : "visibility_off"}
                                                </span>
                                            </button>
                                        </div>
                                    ))}
                                </div>

                                {error && <p className="text-red-600 text-sm mb-4">{error}</p>}

                                <div className="flex justify-center mt-6">
                                    <button type="submit" className="bg-[#2A668D] text-white w-full max-w-xs py-2 rounded-xl">
                                        Register Now
                                    </button>
                                </div>
                            </form>

                            <Link to="/" className="text-[#2A668D] font-bold mt-4 inline-block underline">
                                Go to Login
                            </Link>

                            <div className="my-4">
                                By submitting this, you agree to the
                                <Link to={"/vendor-privacy-policy"}> <span className="text-[#2A668D] font-bold ml-2 mr-2">Privacy Policy</span></Link>  
                                and
                                <Link to={"/vendor-cookie-policy"}> <span className="text-[#2A668D] font-bold ml-2">Cookie Policy</span></Link>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {registrationSuccess && (
                <div
                    onClick={handleOverlayClick}
                    ref={modalRef}
                    className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50 z-50 overflow-auto"
                >
                    <div className="bg-white p-5 md:p-10 w-[80%] max-w-[600px] rounded-lg shadow-md relative">
                        <button className="absolute top-2 right-3 text-xl" onClick={closeModal}>×</button>
                        <div className="flex justify-center mb-4">
                            <svg
                                className="mx-auto w-24 h-24 mb-4 text-[#2A668D]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="12" cy="12" r="10" strokeWidth="2"></circle>
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M9 12l2 2l4-4"
                                ></path>
                            </svg>
                        </div>
                        <p className="text-center text-2xl text-[#2A668D] font-semibold">
                            Verify Your Account
                        </p>
                        <p className="text-center text-md text-[#666666] mt-3">
                            A verification link has been sent to your email address.
                        </p>
                    </div>
                </div>
            )}
        </>
    );
};

export default VendorRegister;
